import { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import Select from "react-select";
import axios from "axios";
import $ from "jquery";
import Swal from "sweetalert2";
import api from "../../utils/axios";
import update from "immutability-helper";
import { validated } from "react-custom-validation";
import { GET_FORMPOST, GET_DETAILDATA } from "../../actions";
import { showLoader, hideLoader, showAlert, isEmpty, isSingleSelect, showContaimerLoader, removeChar, hasPermission } from "../Settings/Settings";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
import { apiUrl, downloadUrl } from "../Settings/Config";
const module = "vessel";
const modulePath = "/vessel";
const moduleName = "Vessel";
const moduleID = 4;
class Form extends Component {
  constructor(props) {
    super(props);
    const editID = this.props.location.state?.editID ?? "";
    this.state = {
      editID,
      postdata: {
        vesselName: "",
        vesselCode: "",
        vsl_company: "",
        vesselType: "",
        imoNumber: "",
        vesselFlag: "",
        vesselGRT: "",
        vesselEngine: "",
        vesselKWT: "",
        vesselStatus: "",
        vesselImages: [],
        vesselParticulars: [],
      },
      detaildata: [],
      companyList: [],
      vessleTypeList: [],
      error_msg: "",
      pageloading: false,
    };
  }

  componentDidMount() {
    if (this.state.editID !== "") {
      if (!hasPermission(moduleID, "edit")) {
        if (hasPermission(moduleID, "view")) {
          this.props.history.push(modulePath);
        } else {
          this.props.history.push("/search");
        }
      }
      const params = {
        params: "",
        url: `${module}/detail/${this.state.editID}`,
      };
      this.setState({ pageloading: true });
      this.props.getDetailData(params);
    } else {
      if (!hasPermission(moduleID, "add")) {
        if (hasPermission(moduleID, "view")) {
          this.props.history.push(modulePath);
        } else {
          this.props.history.push("/search");
        }
      }
    }
    this.loadDropdown();
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.state.formpost !== nextProps.formpost && this.props.formpost !== nextProps.formpost) {
      if (nextProps.formpost.length > 0) {
        hideLoader("submit_frm", "class");
        const errMsg = nextProps.formpost[0].message;
        if (nextProps.formpost[0].status === "ok") {
          showAlert("Success", errMsg, "success", "No");
          this.props.history.push(modulePath);
        } else {
          showAlert("Error", errMsg, "error", "No");
        }
      }
    }
    if (this.state.detaildata !== nextProps.detaildata && nextProps.detaildata !== "" && this.state.editID !== "") {
      this.setState({ detaildata: nextProps.detaildata }, function () {
        if (nextProps.detaildata[0].status === "ok") {
          const result = nextProps.detaildata[0].result;

          const vesselStatus = result.vesselStatus === "A" ? "Active" : "In Active";
          const status =
            result.vesselStatus !== "" && result.vesselStatus !== null
              ? {
                  label: vesselStatus,
                  value: result.vesselStatus,
                }
              : "";
          /* const rpsl = result?.rpsl ?? "No"; */
          const clientupdatedata = {
            vesselName: result.vesselName,
            vesselCode: result.vesselCode,
            vsl_company:
              result.vsl_company !== "" && result.vsl_company !== null && result.company_name !== "" && result.company_name !== null ? { label: result.company_name, value: result.vsl_company } : "",
            vesselType: result.vesselType !== "" && result.vesselType !== null ? { label: result.vesselType, value: result.vesselType } : "",
            imoNumber: result.imoNumber,
            vesselFlag: result.vesselFlag,
            vesselGRT: result.vesselGRT,
            vesselEngine: result.vesselEngine,
            vesselKWT: result.vesselKWT,
            vesselImages: result.vesselImages !== "" && result.vesselImages !== null ? result.vesselImages.split(",") : [],
            vesselParticulars: result.vesselParticulars !== "" && result.vesselParticulars !== null ? JSON.parse(result.vesselParticulars) : [],
            vesselStatus: status,
          };
          this.setState({ postdata: clientupdatedata, pageloading: false });
        } else {
          this.props.history.push(modulePath);
          showAlert("Error", "Invalid" + moduleName, "error");
        }
      });
    }
  }
  loadDropdown() {
    api
      .get("company/dropdown")
      .then((res) => {
        if (res.data.status === "ok") {
          this.setState({ companyList: res.data.result });
        }
      })
      .catch((err) => {
        console.error(err);
      });
    api
      .get("vesseltype/dropdown")
      .then((res) => {
        if (res.data.status === "ok") {
          this.setState({ vessleTypeList: res.data.result });
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }
  sateValChange = (field, value) => {};

  handleChange(checked, name) {
    this.setState({ checked });
  }

  /* signin - start*/
  fieldChange = (field, value) => {
    this.setState(update(this.state, { postdata: { [field]: { $set: removeChar(value) } } }));
  };

  handleSubmit = () => {
    showLoader("submit_frm", "class");
    const postData = this.state.postdata;

    const postObject = {
      vesselName: postData.vesselName.toUpperCase(),
      vesselCode: postData.vesselCode.toUpperCase(),
      vsl_company: postData.vsl_company?.value ?? "",
      vesselType: postData.vesselType?.value ?? "",
      imoNumber: postData.imoNumber.toUpperCase(),
      vesselFlag: postData.vesselFlag.toUpperCase(),
      vesselGRT: postData.vesselGRT,
      vesselEngine: postData.vesselEngine,
      vesselKWT: postData.vesselKWT,
      vesselImages: postData.vesselImages.length > 0 ? postData.vesselImages.join(",") : "",
      vesselParticulars: postData.vesselParticulars.length > 0 ? JSON.stringify(postData.vesselParticulars) : "",
      vesselStatus: postData.vesselStatus?.value ?? "I",
    };

    let post_url = `${module}`;
    let method = "post";
    if (this.state.editID !== "") {
      post_url = `${module}/${this.state.editID}`;
      method = "update";
    }
    this.props.getFormPost(postObject, post_url, method);
  };

  render() {
    return (
      <div>
        <div className="page">
          <div className="page-main">
            <Header currentPage={module} {...this.props} />

            <div className="main-content app-content">
              <div className="side-app">
                <div className="main-container container-fluid  mx-3">
                  <div className="page-header">
                    <h1 className="page-title">
                      {this.state.editID !== "" ? "Update" : "Add New"} {moduleName}
                    </h1>
                    <div>
                      <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                          <Link to={modulePath}>
                            <i className="fa fa-arrow-left me-1"></i>
                            GoBack
                          </Link>
                        </li>
                      </ol>
                    </div>
                  </div>
                  <div className="row" id="modulefrm">
                    <div className="col-md-12 col-xl-12">
                      <div className="card">
                        {this.state.pageloading ? (
                          showContaimerLoader()
                        ) : (
                          <PostForm
                            {...this.props}
                            fields={this.state.postdata}
                            companyList={this.state.companyList}
                            vessleTypeList={this.state.vessleTypeList}
                            onChange={this.fieldChange}
                            onValid={this.handleSubmit}
                            editID={this.state.editID}
                            error_msg={this.state.error_msg}
                            onInvalid={() => {
                              console.log("Form invalid!");
                              setTimeout(function () {
                                if ($("#modulefrm .error").length > 0) {
                                  $("html, body").animate(
                                    {
                                      scrollTop: $(document).find("#modulefrm .error:first").offset().top - 100,
                                    },
                                    500,
                                  );
                                }
                              }, 500);
                            }}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  return {
    formpost: state.formpost,
    detaildata: state.detaildata,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getFormPost: (formPayload, postUrl, method) => {
      dispatch({ type: GET_FORMPOST, formPayload, postUrl, method });
    },
    getDetailData: (datas) => {
      dispatch({ type: GET_DETAILDATA, datas });
    },
  };
};

export default connect(mapStateTopProps, mapDispatchToProps)(Form);

function validationConfig(props) {
  const { vesselName, vsl_company, vesselType, imoNumber, vesselFlag, vesselStatus } = props.fields;

  return {
    fields: ["vesselName", "vsl_company", "vesselType", "imoNumber", "vesselFlag", "vesselStatus"],
    validations: {
      vesselName: [[isEmpty, vesselName]],
      vsl_company: [[isSingleSelect, vsl_company]],
      vesselType: [[isSingleSelect, vesselType]],
      imoNumber: [[isEmpty, imoNumber]],
      vesselFlag: [[isEmpty, vesselFlag]],
      vesselStatus: [[isSingleSelect, vesselStatus]],
    },
  };
}

class PostForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      slectedPDF: "",
    };
  }
  goBack() {
    this.props.history.push(modulePath);
  }
  handleSelectChange(name, value) {
    this.props.onChange(name, value);
  }
  handlecheckedChange(name, e) {
    this.props.onChange(name, e.target.checked);
  }

  handleFileChange = async (uploadType, e) => {
    const file = e.target.files[0];
    if (!file) return false;
    if (uploadType === "vesselParticulars") {
      const allowedTypes = [
        "application/pdf",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      ];
      if (!allowedTypes.includes(file.type)) {
        showAlert("Error", `Only PDF, Word & Excel files allowed!`, "error");
        e.target.value = "";
        return;
      }
    }

    const formData = new FormData();
    formData.append("upfile", file);
    if (uploadType === "vesselImages") {
      formData.append("pathName", "vesselimage");
    } else {
      formData.append("pathName", "vesselparticulars");
    }

    try {
      const response = await axios.post(
        `${apiUrl}vessel/uploadfile`, // Your API endpoint
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: localStorage.getItem("token"),
          },
        },
      );
      if (response.data.success === true) {
        if (uploadType === "vesselImages") {
          let vesselImages = this.props.fields.vesselImages;
          const fileName = response.data.fileName;
          vesselImages.push(fileName);

          document.getElementById(uploadType).value = "";
          this.props.onChange(uploadType, vesselImages);
        } else {
          let vesselParticulars = this.props.fields.vesselParticulars;
          const fileName = response.data.fileName;
          vesselParticulars.push(fileName);

          document.getElementById(uploadType).value = "";
          this.props.onChange(uploadType, vesselParticulars);
        }
      }

      console.log("Upload Success:", response.data);
    } catch (error) {
      console.error("Upload Error:", error);
      alert("File upload failed");
    }
  };
  viewvesselParticular(slectedPDF, e) {
    e.preventDefault();
    const slectedPDF_ = slectedPDF?.pathName ?? "";
    if (slectedPDF_ !== "") {
      const slectedPDFSplit_ = slectedPDF_.split(".");
      if (slectedPDFSplit_[slectedPDFSplit_.length - 1].toLowerCase() === "pdf") {
        this.setState({ slectedPDF }, () => {
          $("#viewPerticular").trigger("click");
        });
      } else {
        window.open(`${downloadUrl}uploads/vesselparticulars/${slectedPDF.pathName}`, "_blank");
      }
    }
  }
  removeVesselType(removeIndex, fileType, e) {
    e.preventDefault();
    Swal.fire({
      title: "Are you sure?",
      text: "You want remove this item!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      customClass: {
        confirmButton: "btn btn-primary me-3 waves-effect waves-light",
        cancelButton: "btn btn-label-secondary waves-effect",
      },
      buttonsStyling: false,
      showLoaderOnConfirm: true,
      preConfirm: () => {
        try {
          if (fileType === "vesselParticulars") {
            let vesselParticulars = this.props.fields.vesselParticulars;
            vesselParticulars.splice(removeIndex, 1);
            this.props.onChange(fileType, vesselParticulars);
          } else if (fileType === "vesselImages") {
            let vesselImages = this.props.fields.vesselImages;
            vesselImages.splice(removeIndex, 1);
            this.props.onChange(fileType, vesselImages);
          }
        } catch (err) {
          console.log(err);
        }
      },
      allowOutsideClick: () => !Swal.isLoading(),
    }).then(() => {});
  }

  render() {
    const { fields, onChange, onValid, onInvalid, $field, $validation } = this.props;
    let errMsgvesselName,
      errMsgvsl_company,
      errMsgvesselType,
      errMsgimoNumber,
      errMsgvesselFlag,
      errMsgStatus = "";
    if ($validation.vesselName.error.reason !== undefined) {
      errMsgvesselName = $validation.vesselName.show && <span className="error">{$validation.vesselName.error.reason}</span>;
    }
    if ($validation.vsl_company.error.reason !== undefined) {
      errMsgvsl_company = $validation.vsl_company.show && <span className="error">{$validation.vsl_company.error.reason}</span>;
    }
    if ($validation.vesselType.error.reason !== undefined) {
      errMsgvesselType = $validation.vesselType.show && <span className="error">{$validation.vesselType.error.reason}</span>;
    }

    if ($validation.imoNumber.error.reason !== undefined) {
      errMsgimoNumber = $validation.imoNumber.show && <span className="error">{$validation.imoNumber.error.reason}</span>;
    }

    if ($validation.vesselFlag.error.reason !== undefined) {
      errMsgvesselFlag = $validation.vesselFlag.show && <span className="error">{$validation.vesselFlag.error.reason}</span>;
    }
    if ($validation.vesselStatus.error.reason !== undefined) {
      errMsgStatus = $validation.vesselStatus.show && <span className="error">{$validation.vesselStatus.error.reason}</span>;
    }

    return (
      <div>
        <button class="btn btn-secondary bg-secondary-gradient mt-3" data-bs-toggle="modal" data-bs-target="#extralargemodal" id="viewPerticular" style={{ display: "none" }}>
          Extralarge Modal
        </button>
        <div className="card-body">
          <div className="form-row">
            <div className="form-group col-md-3">
              <label className="form-label">
                Vessel Name<span className="lbl-error">*</span>
              </label>
              <input
                type="text"
                className="form-control  upper-case"
                placeholder="Vessel Name"
                name="vesselName"
                value={fields.vesselName}
                {...$field("vesselName", (e) => onChange("vesselName", e.target.value))}
              />
              {errMsgvesselName}
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">Vessel Code</label>
              <input
                type="text"
                className="form-control  upper-case"
                placeholder="Vessel Code"
                name="vesselCode"
                value={fields.vesselCode}
                {...$field("vesselCode", (e) => onChange("vesselCode", e.target.value))}
                maxLength={10}
              />
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">
                Company Name<span className="lbl-error">*</span>
              </label>
              <Select value={fields.vsl_company} onChange={this.handleSelectChange.bind(this, "vsl_company")} placeholder="Select Company Name" isClearable={true} options={this.props.companyList} />
              {errMsgvsl_company}
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">
                Vessel Type<span className="lbl-error">*</span>
              </label>
              <Select value={fields.vesselType} onChange={this.handleSelectChange.bind(this, "vesselType")} placeholder="Select Vessel Type" isClearable={true} options={this.props.vessleTypeList} />
              {errMsgvesselType}
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">
                IMO Number<span className="lbl-error">*</span>
              </label>
              <input
                type="text"
                className="form-control  upper-case"
                placeholder="IMO Number"
                name="imoNumber"
                value={fields.imoNumber}
                {...$field("imoNumber", (e) => onChange("imoNumber", e.target.value))}
              />
              {errMsgimoNumber}
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">
                Flag<span className="lbl-error">*</span>
              </label>
              <input
                type="text"
                className="form-control  upper-case"
                placeholder="Flag"
                name="vesselFlag"
                value={fields.vesselFlag}
                {...$field("vesselFlag", (e) => onChange("vesselFlag", e.target.value))}
              />
              {errMsgvesselFlag}
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">GRT</label>
              <input
                type="text"
                className="form-control upper-case"
                placeholder="GRT"
                name="vesselGRT"
                value={fields.vesselGRT}
                {...$field("vesselGRT", (e) => onChange("vesselGRT", e.target.value))}
              />
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">Engine</label>
              <input
                type="text"
                className="form-control upper-case"
                placeholder="Engine"
                name="vesselEngine"
                value={fields.vesselEngine}
                {...$field("vesselEngine", (e) => onChange("vesselEngine", e.target.value))}
              />
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">KWT</label>
              <input
                type="text"
                className="form-control upper-case"
                placeholder="KWT"
                name="vesselKWT"
                value={fields.vesselKWT}
                {...$field("vesselKWT", (e) => onChange("vesselKWT", e.target.value))}
              />
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">
                Status<span className="lbl-error">*</span>
              </label>
              <Select
                value={fields.vesselStatus}
                onChange={this.handleSelectChange.bind(this, "vesselStatus")}
                placeholder="Select Status"
                isClearable={true}
                options={[
                  { value: "A", label: "Active" },
                  { value: "I", label: "In Active" },
                ]}
              />
              {errMsgStatus}
            </div>
            <div class="col-md-12 col-lg-12"></div>
            <div class="row" style={{ width: "100%" }}>
              <div className="form-group col-md-3">
                <div class="form-group">
                  <label class="form-label">Vessel Images</label>
                  <input class="form-control" type="file" id="vesselImages" onChange={this.handleFileChange.bind(this, "vesselImages")} />
                </div>
              </div>

              {fields.vesselImages.length > 0 && (
                <div class="col-md-12 col-lg-12">
                  <div class="card">
                    <div class="row">
                      {fields.vesselImages.map((item, index) => {
                        return (
                          <div class="col-md-6 col-xl-3 image-list" key={index}>
                            <a href="/" onClick={this.removeVesselType.bind(this, index, "vesselImages")} class="tag-orange remove-image">
                              <i class="fe fe-x text-white m-1"></i>
                            </a>
                            <a
                              href="/"
                              onClick={(e) => {
                                e.preventDefault();
                              }}
                              class="thumbnail "
                            >
                              <img src={`${downloadUrl}uploads/vesselimage/${item}`} alt="thumb1" class="thumbimg" />
                            </a>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div class="row" style={{ width: "100%" }}>
              <div className="form-group col-md-3">
                <div class="form-group">
                  <label class="form-label">Vessel Documents</label>
                  <input class="form-control" type="file" id="vesselParticulars" accept=".pdf, .doc, .docx, .xls, .xlsx" onChange={this.handleFileChange.bind(this, "vesselParticulars")} />
                </div>
              </div>
              {fields.vesselParticulars.length > 0 && (
                <div className="form-group col-md-12">
                  {fields.vesselParticulars.map((item, index) => {
                    return (
                      <span class="tag tag-rounded tag-icon tag-orange mx-2" key={index}>
                        <span onClick={this.viewvesselParticular.bind(this, item)}>
                          <i class="fa fa-file-pdf-o"></i>
                          {item.fileName}
                        </span>{" "}
                        <a href="/" onClick={this.removeVesselType.bind(this, index, "vesselParticulars")} class="tag-addon tag-addon-cross tag-orange">
                          <i class="fe fe-x text-white m-1"></i>
                        </a>
                      </span>
                    );
                  })}
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="card-footer">
          <div className="btn-toolbar sw-toolbar sw-toolbar-bottom justify-content-end">
            <div className="btn-group me-2 sw-btn-group-extra submit_frm" role="group">
              <button
                className="btn btn-primary"
                onClick={(e) => {
                  e.preventDefault();
                  this.props.$submit(onValid, onInvalid);
                }}
              >
                {this.props.editID !== "" ? "Update" : "Add New"}
              </button>

              <button className="btn btn-secondary" onClick={this.goBack.bind(this)}>
                Cancel
              </button>
            </div>
          </div>
        </div>
        <div class="modal fade" id="extralargemodal" tabindex="-1" role="dialog">
          <div class="modal-dialog modal-xl" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Particulars Details</h5>
                <button class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div class="modal-body">
                {this.state.slectedPDF !== "" && <iframe src={`${downloadUrl}uploads/vesselparticulars/${this.state.slectedPDF.pathName}`} width="100%" height="500px" title="view File"></iframe>}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
PostForm = validated(validationConfig)(PostForm);
